import { render, staticRenderFns } from "./ProductEquipmentStatusMonitoringView.vue?vue&type=template&id=bc64c544"
import script from "./ProductEquipmentStatusMonitoringView.vue?vue&type=script&lang=js"
export * from "./ProductEquipmentStatusMonitoringView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports